exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rule-lable {\n  padding: 10px 15px;\n  margin-right: 20px;\n  color: white;\n  background-color: var(--lightblue);\n  border: 1px solid var(--lightblue);\n  border-radius: 5px;\n}\n\n.rule-block {\n  justify-content: center;\n  flex: 1 1;\n}\n\n.rule-list-left {\n  margin-right: 15%;\n}\n\n.rule-switch {\n  margin-top: 50px;\n}\n", ""]);

// exports
